module.exports = __webpack_public_path__ + "static/media/my.e6739f40.svg";